import React, { ReactNode } from 'react';
import { Box, Divider, Grid, Paper, SxProps, Theme, Typography } from '@mui/material';

interface SectionWithPaperProps {
  title: string | ReactNode;
  children: ReactNode;
  fullWidth?: boolean;
  paperSx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
  dividerSx?: SxProps<Theme>;
  gridSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
}

/**
 * 見出し付きのペーパーセクションを表示するコンポーネント
 */
const SectionWithPaper: React.FC<SectionWithPaperProps> = ({
  title,
  children,
  fullWidth = false,
  paperSx,
  titleSx,
  dividerSx,
  gridSx,
  contentSx
}) => {
  // スタイルをマージする関数
  const mergeStyles = (baseStyles: any, additionalStyles?: SxProps<Theme>) => {
    if (!additionalStyles) return baseStyles;
    return Object.assign({}, baseStyles, additionalStyles);
  };

  const content = (
    <>
      {typeof title === 'string' ? (
        <Typography variant="h6" gutterBottom sx={titleSx}>
          {title}
        </Typography>
      ) : (
        title
      )}
      <Divider sx={mergeStyles({ mb: 2 }, dividerSx)} />
      <Paper 
        variant="outlined" 
        sx={mergeStyles({ p: 2 }, mergeStyles(paperSx, contentSx))}
      >
        {children}
      </Paper>
    </>
  );

  if (fullWidth) {
    return <Box sx={{ width: '100%' }}>{content}</Box>;
  }

  return (
    <Grid item xs={12} md={6} sx={gridSx}>
      {content}
    </Grid>
  );
};

export default SectionWithPaper;